export const BACKEND_URL = 'https://api3.insightmonk.com'
export const BACKEND_URL2 ='https://api2.insightmonk.com'
